import React, { useCallback, useState } from "react";
import { Collapse, IconButton } from "@material-ui/core";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { ArrowIcon } from "../../../../icons";
import { trackMobileNavEvent } from "../../analytics";
var useStyles = makeStyles(createStyles({
    divider: {
        borderTop: "solid 1px #d8d8d8",
    },
    heading: {
        display: "grid",
        gridTemplateColumns: "1fr auto",
        "&.first-item": {
            marginTop: 8,
        },
    },
    title: {
        fontSize: 20,
        fontWeight: 800,
        lineHeight: "26px",
        color: "#010414",
        padding: "16px 0",
    },
    arrow: {
        padding: 0,
        transform: function (_a) {
            var expand = _a.expand;
            return (expand ? "rotate(180deg)" : "none");
        },
        transition: "transform 250ms ease",
        "&:hover": {
            backgroundColor: "transparent",
        },
    },
    items: {
        fontSize: 16,
        lineHeight: "22px",
        color: "#010414",
        margin: "24px 0",
        "&:first-child": {
            marginTop: 8,
        },
    },
}));
var DrawerItem = function (props) {
    var name = props.name, links = props.links, url = props.url, _a = props.open, open = _a === void 0 ? false : _a, onClose = props.onClose, index = props.index;
    var _b = useState(open), expand = _b[0], setExpand = _b[1];
    var styles = useStyles({ expand: expand });
    var redirect = useCallback(function (name, href) {
        if (href) {
            trackMobileNavEvent(name, href);
            onClose && onClose();
            window.location.href = href;
        }
    }, [onClose]);
    var handleHeadingClick = useCallback(function (name) {
        if (links)
            setExpand(function (state) { return !state; });
        else
            redirect(name, url);
    }, [links, redirect]);
    return (React.createElement(React.Fragment, null,
        index !== 0 && React.createElement("div", { className: styles.divider }),
        React.createElement("div", { className: clsx(styles.heading, index === 0 && "first-item"), id: "headerMobile" + name.replace(/\s+|\W+/g, ""), onClick: function () { return handleHeadingClick(name); } },
            React.createElement("div", { className: styles.title }, name),
            links && (React.createElement(IconButton, { className: styles.arrow, disableRipple: true },
                React.createElement(ArrowIcon, { color: "#e6007d" })))),
        links && (React.createElement(Collapse, { in: expand }, links.map(function (item, index) { return (React.createElement("div", { key: index, className: styles.items, onClick: function () { return redirect(item.name, item.url); } }, item.name)); })))));
};
export default DrawerItem;
